import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren, useMemo } from "react";
import { FormDefinitions, Stage } from "../../api/dtos";
import { useParams } from "react-router-dom";

export interface IStageFormByIdRouteProps extends PropsWithChildren {
    stageId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const StageFormByIdRoute: FC<IStageFormByIdRouteProps> = ({
    stageId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const stageIdToUse = (params.stageId ? +params.stageId : undefined) ?? stageId ?? undefined;

    const projectId = params.projectId ? +params.projectId : undefined;

    const createData = useMemo(() => new Stage({
        projectId
    }), [projectId]);

    return (
        <ContextFormByIdProvider
            formId={stageIdToUse}
            formDefinitionIdentifier={FormDefinitions.Stage}
            createData={createData}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default StageFormByIdRoute;
